function Configuration() {
    return (
        <div className="fs-3">Configuration</div>
    );
}

export default Configuration;